<template>
       <div class="file-link-wrapper">
         <a :href="fileUrl" target="_blank" class="file-link">
           <img v-if="iconSrc" :src="iconSrc" alt="Иконка файла" class="file-icon" />
           <span class="file-name">{{ fileName }}<span v-if="format" class="file-format">{{ format }}</span></span>
         </a>
         <hr v-if="iconSrc" class="file-link-hr"/>
       </div>
 </template>

  <script setup>

    const props = defineProps({
      fileUrl: {
        type: String,
        required: true,
      },
      fileName: {
        type: String,
        required: true,
      },
      iconSrc: {
        type: String,
        required: false,
      },
      format: {
        type: String,
        required: false,
      }
    });

  </script>

    <style scoped>
    .file-link-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .file-link-hr {
      border: none;
      height: 1px;
      background-color: #E4E6E7;
      width: 100%;
      margin: 0;
    }

    .file-link {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      gap: 8px;
    }

    .file-format {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      color: #AAAAAA;
    }

    .file-icon {
      width: 24px;
      height: 24px;
    }

    .file-name {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0%;
        color: #48538B;
        display: flex;
        align-items: center;
        gap: 8px;
    }
</style>